var React = require('react');

function Stop (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M19.8333 19.8333L36.1667 36.1666M19.8333 36.1666L28 28L36.1667 19.8333","stroke":"#D61F49","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M35.7574 7H20.2426C19.447 7 18.6839 7.31607 18.1213 7.87868L7.87868 18.1213C7.31607 18.6839 7 19.447 7 20.2426V35.7574C7 36.553 7.31607 37.3161 7.87868 37.8787L18.1213 48.1213C18.6839 48.6839 19.447 49 20.2426 49H35.7574C36.553 49 37.3161 48.6839 37.8787 48.1213L48.1213 37.8787C48.6839 37.3161 49 36.553 49 35.7574V20.2426C49 19.447 48.6839 18.6839 48.1213 18.1213L37.8787 7.87868C37.3161 7.31607 36.553 7 35.7574 7Z","stroke":"#D61F49","strokeWidth":"1.5","key":1})]);
}

Stop.defaultProps = {"width":"56","height":"56","viewBox":"0 0 56 56","fill":"none"};

module.exports = Stop;

Stop.default = Stop;
